import { useQueryParamsAsKeyValuePair } from 'hooks/useQueryParams';
import { debounce, get } from 'lodash';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import SearchAction from 'redux/search/search.actions';
import SearchSelectors from 'redux/search/search.selectors';
import { SearchScopeEnum } from 'redux/search/types';
import { GeneralFunction } from 'types/common';
import { getNewQueryString } from 'utils';

// import APIService from 'services/apiUtils';
import SearchBarTemplate from './SearchBarTemplate';

const SearchBarSuggestion: React.FC<{
  onSearch?: GeneralFunction;
  entities?: SearchScopeEnum[];
  name?: string;
  placeholder?: string;
}> = ({ onSearch, entities, name = 'query', placeholder = 'Search...' }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { location } = history;
  const queryObject = useQueryParamsAsKeyValuePair();
  const searchSelector = useSelector(SearchSelectors.selectSearch);
  const searchInput = searchSelector.currentSearchInput;
  const searchResult = searchSelector.transactionSearch;
  const options: { label: string; value: string }[] = useMemo(
    () => searchResult?.[searchInput]?.map((sVal) => ({ label: sVal, value: sVal })),
    [searchResult],
  );

  const handleSearch = useMemo(
    () =>
      debounce((v: string) => {
        dispatch(SearchAction.fetchSearchSuggestionStart(v || '', entities));
      }, 150),
    [],
  );

  const onSearchStart = (v: any) => {
    console.log('on search start');
    const searchKey = get(v, 'current.state.value') || searchInput;
    if (onSearch) {
      onSearch(searchKey);
      return;
    }

    const newQuery = getNewQueryString(history.location.search, { [name]: searchKey });
    history.push({
      pathname: location.pathname,
      search: newQuery,
    });
  };

  return (
    <SearchBarTemplate
      onSearchStart={onSearchStart}
      options={options}
      onSearch={handleSearch}
      placeholder={placeholder}
      value={queryObject?.[name] || ''}
    />
  );
};

export default React.memo(SearchBarSuggestion);
